<template>
  <div>
    <vs-popup :title="$t('UserRoles')" :active.sync="popupActive">
      <loading v-if="showLoading"></loading>
      <div>
        <div class="vx-row">
          <div class="vx-col flex rolelist w-full">
            <div
              v-for="role in roleModel"
              :key="role.id"
              class="flex permission"
            >
              <vs-checkbox v-model="role.isSelected">
                {{ role.name }}</vs-checkbox
              >
            </div>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full">
            <vs-button
              type="filled"
              class="float-right"
              @click.prevent="submitForm"
              :disabled="disableOnSubmit"
              >{{ $t("Save") }}</vs-button
            >
          </div>
        </div>
      </div>
    </vs-popup>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import Loading from "@/components/loading/Loading.vue";

export default {
  name: "user-management-Users-RolePopup",
  components: {
    Loading,
  },
  props: {
    show: { default: false },
    roleModel: {},
    userId: null,
  },
  data() {
    return {
      RolePopup: false,
      disableOnSubmit: false,
      model: [],
      showLoading: false,
    };
  },
  computed: {
    popupActive: {
      get: function () {
        return this.show;
      },
      set: function () {
        this.$emit("finish");
      },
    },
  },
  methods: {
    ...mapActions({
      updateUserRoles: "user/updateUserRoles",
    }),
    updateModel() {
      this.model.userRoles = [];
      var array = this.roleModel;
      for (var i = 0; i < array.length; i++) {
        this.model.userRoles.push({
          roleId: array[i].roleId,
          isSelected: array[i].isSelected,
          roleName: array[i].name,
        });
      }
    },
    submitForm() {
      this.updateModel();
      this.disableOnSubmit = true;
      this.updateUserRoles(this.model).then(() => {
        this.$swal({
          position: "center-center",
          type: "success",
          text: "رکورد مورد‌نظر با موفقیت ویرایش شد!",
          showConfirmButton: false,
          timer: 2000,
        });
        this.$emit("finish");
        this.model = [];
        this.disableOnSubmit = false;
      });
    },
  },
  watch: {
    show() {
      this.model = {
        userId: this.userId,
        userRoles: [],
      };
      if (this.show == true) {
        setTimeout(() => {
          this.loaded = false;
        }, 200);
      } else {
        this.loaded = true;
      }
    },
  },
};
</script>
